<div class='left-menu'>
  <ul class='nav navbar-nav'>
    @if (!defaults.isReadonlyUser) {
      <li [routerLinkActive]="['link-active']">
        <a class='menu-callback' (click)="newEvent.emit({})" title="Create a new Maintenance Control Plan">
          <span class='glyphicon glyphicon-plus-sign'></span> New MCP
        </a>
      </li>
    }

    @if (!defaults.isReadonlyUser) {
      <li class="separator" [ngClass]="saveService.classSaveButton"></li>
    }
    @if (!defaults.isReadonlyUser) {
      <li [routerLinkActive]="['link-active']" [ngClass]="saveService.classSaveButton">
        <a class='menu-callback' (click)="saveService.fireSave()" title="Save all Error Code(s) and Resolution(s)">
          <span class='glyphicon glyphicon-floppy-disk'></span> Save
        </a>
      </li>
    }

  </ul>
</div>